import { DropdownMenuItem } from '@solinkcorp/solink-ui';
import { useQueryParams } from '@solinkcorp/utils/hooks';
import { Moon, Sun } from 'lucide-react';
import React, { useCallback } from 'react';
import { ICON_SIZE, SDM_THEME_QUERY_PARAM, SDM_THEME_QUERY_VALUE_DARK } from '../../constants';

const DarkModeMenuItem: React.FC = () => {
  const [query, setQuery] = useQueryParams();
  const darkMode = query.get(SDM_THEME_QUERY_PARAM) === SDM_THEME_QUERY_VALUE_DARK;

  const toggleDarkMode = useCallback(() => {
    if (darkMode) {
      setQuery({ [SDM_THEME_QUERY_PARAM]: undefined }, true);
    } else {
      setQuery({ [SDM_THEME_QUERY_PARAM]: SDM_THEME_QUERY_VALUE_DARK }, true);
    }
  }, [darkMode, setQuery]);

  return (
    <DropdownMenuItem onClick={toggleDarkMode} data-testid="sdm-theme-toggle">
      {darkMode ? <Sun size={ICON_SIZE} /> : <Moon size={ICON_SIZE} />}
      {darkMode ? 'Light Mode' : 'Dark Mode'}
    </DropdownMenuItem>
  );
};

export default React.memo(DarkModeMenuItem);
